"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var navbarStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    appBarSpacer: theme.mixins.toolbar,
    combinedShapeImg: {
      bottom: '1.8125rem',
      position: 'fixed',
      left: '4.8125rem',
      zIndex: -99999
    },
    container: {
      paddingBottom: theme.spacing(4),
      paddingTop: theme.spacing(4)
    },
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto'
    },
    drawerPaper: {
      background: theme.palette.tertiary.primary,
      color: theme.palette.text.main,
      maxWidth: function maxWidth(_ref) {
        var isOpen = _ref.isOpen;
        return isOpen ? '14.813rem' : '5.25rem';
      },
      position: 'relative',
      transition: theme.transitions.create('width', {
        duration: theme.transitions.duration.enteringScreen,
        easing: theme.transitions.easing.sharp
      }),
      whiteSpace: 'nowrap',
      paddingRight: theme.spacing(4)
    },
    drawerPaperClose: _defineProperty({
      minWidth: '5.75rem',
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        duration: theme.transitions.duration.leavingScreen,
        easing: theme.transitions.easing.sharp
      }),
      width: theme.spacing(10)
    }, theme.breakpoints.up('sm'), {
      width: theme.spacing(9)
    }),
    grid: {
      margin: '2.5rem auto'
    },
    gridCollapsed: {// marginLeft: '-1rem',
    },
    logo: {
      width: '2.5rem',
      height: '2.5rem'
    },
    logoWide: {
      width: '9.063rem'
    },
    paper: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
      padding: theme.spacing(2)
    },
    profile: {
      height: '5.5rem',
      width: '5.5rem',
      borderRadius: '50%'
    },
    profileSetting: {
      borderRadius: '50%',
      backgroundColor: theme.palette.tertiary.primary,
      // color: theme.palette.text.white,
      cursor: 'pointer',
      // '&:parent': {
      //   minWidth: '0rem',
      // },
      marginLeft: '-1.5rem',
      width: '1.5rem',
      height: '1.5rem',
      padding: '0.2rem'
    },
    profileContainer: {
      '& > div.MuiListItemIcon-root': {
        minWidth: '0rem'
      }
    },
    toolbar: {
      color: theme.palette.tertiary.primary,
      paddingRight: 24 // keep right padding when drawer closed

    },
    toolbarIcon: _objectSpread({
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '0 0.5rem'
    }, theme.mixins.toolbar),
    profileName: {
      // marginRight: '3.5rem',
      // color: theme.palette.text.white,
      textAlign: 'center'
    }
  };
});
var _default = navbarStyles;
exports.default = _default;